import '../../../common/dashboard/filters/applied/applied_multiple_values_filter_view.js.coffee'
import '../../../common/dashboard/filters/assigned_advisor_filter_mixin.js.coffee'

Namespace 'CustomerVisualMode.Filters.Applied'

class CustomerVisualMode.Filters.Applied.AppliedAssignedAdvisorFilterView extends
Common.Dashboard.Filters.AppliedMultipleValuesFilterView

  initialize: ({filter, advisors, isReadOnly}) ->
    super({filter, isReadOnly})
    _.extend(@, Common.Dashboard.Filters.AssignedAdvisorFilterMixin)
    @filter = filter
    @advisors = advisors
    @valueViews = []
    @listenTo(@advisors, 'update', @render)

  _values: ->
    @filter.getValues(@advisors.models)

  _seeAll: ->
    @openAssignedAdvisorFilterModal()
